export const ICON_WIDTH = 25
export const ICON_HEIGHT = 25
export const ICON_WIDTH_PADDING = 10
export const ICON_WIDTH_OFFSET = 10
